import { Locale } from '@dreryk/address-common-api';
import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { PatientUnconfirmedFormBean } from '../patientUnconfirmedUpdate.types';

export const isPatientDataConsistent = (
   patient: PatientUnconfirmedFormBean,
   comparedPatient: Omit<PatientSimple, 'medicalDocumentationCreated'>,
   locale: Locale
): boolean => {
   const comparedPatientFirstName = comparedPatient.firstName?.asString();
   const comparedPatientLastName = comparedPatient.lastName?.asString();
   const comparedPatientPhoneNumber = comparedPatient.phoneNumber?.asString();
   const comparedPatientCountry = comparedPatient.address?.getCountry().getName(locale);
   const comparedPatientTown = comparedPatient.address?.findTown()?.getName();
   const comparedPatientPostcode = comparedPatient.address?.findPostcode()?.asString();
   const comparedPatientStreet = comparedPatient.address?.findStreet()?.asString();
   const comparedPatientBuilding = comparedPatient.address?.findBuilding()?.asString();
   const comparedPatientFlat = comparedPatient.address?.findFlat()?.asString();
   const comparedPatientEmail = comparedPatient.emailAddress?.asString();
   return (
      (comparedPatientFirstName ? patient.firstName === comparedPatientFirstName : true) &&
      (comparedPatientLastName ? patient.lastName === comparedPatientLastName : true) &&
      (comparedPatientPhoneNumber ? patient.phoneNumber?.asString() === comparedPatientPhoneNumber : true) &&
      (comparedPatientCountry ? patient.country.getName(locale) === comparedPatientCountry : true) &&
      (comparedPatientTown ? patient.town === comparedPatientTown : true) &&
      (comparedPatientPostcode ? patient.postcode?.asString() === comparedPatientPostcode : true) &&
      (comparedPatientStreet ? patient.street === comparedPatientStreet : true) &&
      (comparedPatientBuilding ? patient.house === comparedPatientBuilding : true) &&
      (comparedPatientFlat ? patient.flat === comparedPatientFlat : true) &&
      (comparedPatientEmail ? patient.emailAddress?.asString() === comparedPatientEmail : true)
   );
};
